import React from "react";

export const Button = ({
    text,
    onClick,
    disabled,
    icon,
    className,
}: {
    text: string;
    onClick: () => void;
    disabled?: boolean;
    icon?: React.ReactNode;
    className: string;
}) => {
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`
                w-full
                p-[14px]
                bg-primary  
                text-white rounded-[6px] text-[20px] font-semibold leading-[28px] tracking-[0.1px]
            ${className}`}
        >
            <div className="flex flex-row items-center justify-center gap-x-[8px]">
                {icon && <div className="mr-2">{icon}</div>}
                {text}
            </div>
        </button>
    );
};
